export default __webpack_public_path__ + "static/media/pipelines-sumClicks.30649f82.svg";